import { Box, Button, Grid, useTheme } from "@mui/material";
import {
	CLIENT_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import {
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { IResponse, IServerError } from "../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	setSelectedActivityLogActions,
	setSelectedDrawerMenu,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminClientRoutesComponent } from "../RoleBasedLeftMenu/routes/AdminClientRoutes";
import { ClientRoutesComponent } from "../RoleBasedLeftMenu/routes/ClientRoutes";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { ITeams } from "../../models/Teams";
import { PrimeDataGrid } from "../PrimeDataGrid";
import { TeamsService } from "../../services/TeamsService";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { useNavigateToLogout } from "../../common/Common";

export interface ITeamsList { }
const CLIENT_LIST_QUERY_KEY = "teams-list";

const useTeamses = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["teams-list", params],
		queryFn: (data) => {

			return TeamsService.getTeams(clientId, params, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

export const TeamsList: React.FC<ITeamsList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "teamLabel",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { id } = useSelector((state: IAppState) => state.accountant);
	const { isPending, data } = useTeamses(
		clientIdStore,
		queryParams,
		navigateToLogout
	); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const teamsList: any | null = data;

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroTeams, setzeroTeams] = useState(true);
	const [teamsListUpdatedItems, setTeamsListUpdatedItems] =
		useState<any>(undefined);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [teamsId, setTeamsId] = useState<any>(0);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkTeamsId, setBulkTeamsId] = useState<any>({});
	const [bulkTeamsDelete, setBulkTeamsDelete] = useState<boolean>(false);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by: "teamLabel",
			order_direction:
				requestParams.sortField !== null
					? requestParams.sortField
					: requestParams.sortOrder
						? requestParams.sortOrder
						: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroTeams(false);
	};

	const onRowEditClicked = useCallback((params: ITeams) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/company/teams/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	// For Delete Row
	const deleteTeamsField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				teamsId: teamsId,
				navigateToLogout: navigateToLogout,
			};
			deleteTeamsById(delPayload);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: ITeams) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		setTeamsId(params.id);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteTeamsById } = useMutation({
		mutationFn: TeamsService.delTeams,

		onSuccess: (res: string | IServerError | IResponse | any) => {

			if (res) {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : "success",
				});

				return queryClient.invalidateQueries({
					queryKey: [CLIENT_LIST_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setStatusValue(event.target.value as string);
		setApiAction("updateStatus");
		setDialogOpen(true);
	};

	// const onKeyFieldClickHandler = (clickedRow: any) => {
	// dispatch(setSelectedTeams(clickedRow));
	// dispatch(setSelectedTeamsName(clickedRow));
	// };

	//bulk delete

	const { isPending: isBulkDeleting, mutate: deleteBulkTeamses } = useMutation({
		mutationFn: TeamsService.delBulkTeamses,

		onSuccess: (res: any | string | IServerError | IResponse) => {
			if (typeof res === "object") {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : "success",
				});

				setBulkTeamsDelete(false);
				return queryClient.invalidateQueries({
					queryKey: [CLIENT_LIST_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			setBulkTeamsDelete(false);
		},
		onError: (err: any) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: err.message,
				severity: "error",
			});
			setBulkTeamsDelete(false);
		},
	});

	// For Bulk Delete
	const deleteBulkTeamsField = () => {
		if (bulkDelete) {
			setBulkDelete(false);
			let payload = {
				teamsIds: bulkTeamsId,
				navigateToLogout: navigateToLogout,
			};
			deleteBulkTeamses(payload);
			setDialogOpen(false);
		}
	};

	const onRowMultipleDeleteClicked = (params: any) => {

		let bulkDeletePayload = {
			teamsIds: { teamsIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkTeamsId(bulkDeletePayload);
		setBulkTeamsDelete(true);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);

		if (selectedItems.length) {
			return (
				<Box sx={{ marginTop: theme.spacing(1) }}>
					<Button
						onClick={() => onRowMultipleDeleteClicked(selectedItems)}
						variant="contained"
						color="error"
					>
						Delete
					</Button>
				</Box>
			);
		}
		return (
			<Box sx={{ marginTop: theme.spacing(1) }}>
				<RouterLinkButton to="/company/teams/setup" text="Add Teams" />
			</Box>
		);
	}, []);

	const upadtedTeamsListItems = useMemo(() => {
		return (
			teamsList &&
			teamsList.items &&
			teamsList?.items.map((item: any) => ({
				...item,
				title: (
					<Link
						to={`/company/teams/setup/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
					>
						{item.title}
					</Link>
				),
			}))
		);
	}, [teamsList]);



	const expandedLabels = ["Company", "Teams"];
	const expandedTeamsListOrSetupItem = "List"; // Special case for "List" under "Teams"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Teams" &&
				item.label === expandedTeamsListOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: isExpanded,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: CLIENT_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));


		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_teams_list.png";

	return teamsList &&
		teamsList.items &&
		teamsList.items.length === 0 &&
		zeroTeams === true ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Teams to proceed`}
			content={`You can add Teams by directly clicking on add Teams button.`}
			testId={"teams-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add Teams"}
			navigateToAdd={"/company/teams/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={
						bulkTeamsDelete === true ? deleteBulkTeamsField : deleteTeamsField
					}
					cancelActionHandler={onCloseHandler}
					testId="tax-profile-tab-confirmation-dialog"
				/>
				<PrimeDataGrid
					columns={teamsList ? teamsList.headerColumns : []}
					rows={teamsList && upadtedTeamsListItems ? upadtedTeamsListItems : []}
					showIndexColumn={true}
					showChecboxColumn={isAdminUser === 400 ? true : false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={isPending || isDeleting || isBulkDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={teamsList && teamsList.total ? teamsList.total : 0}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search by Teams Name..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroTeams(value)
					}
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
